









































import { Component, Prop } from 'vue-property-decorator';
import { CheckIcon, MailIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import Avatar from '@/components/common/Avatar.vue';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';
import UserCard from '@/components/common/UserCard.vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';

@Component({
  components: {
    FormSubmit,
    UserCard,
    UserStatusBadge,
    Avatar,
    XIcon,
    CheckIcon,
    MailIcon,
  },
})
export default class MagicLinkModal extends mixins(BaseMixin) {
  @Prop({ required: true, type: String })
  email!: string;

  cancel() {
    //
  }
}
